module.exports = __webpack_public_path__ + "img/background-5.90fe1709.jpg";